import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../../lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-[var(--radius-badge)] font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'bg-primary text-white',
        secondary: 'bg-secondary text-foreground',
        destructive: 'bg-error text-white',
        outline: 'border border-border text-foreground bg-transparent',
        success: 'bg-success text-white',
        warning: 'bg-warning text-foreground',
      },
      size: {
        default: 'px-2.5 py-0.5 text-xs',
        sm: 'px-2 py-0.5 text-[10px]',
        lg: 'px-3 py-1 text-sm',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
)

interface BadgeProps
  extends React.ComponentPropsWithoutRef<'div'>,
    VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<React.ComponentRef<'div'>, BadgeProps>(
  ({ className, variant, size, ...props }, ref) => (
    <div ref={ref} className={cn(badgeVariants({ variant, size, className }))} data-figma-component="Badge" data-figma-variant={variant || 'default'} data-figma-size={size || 'default'} {...props} />
  )
)
Badge.displayName = 'Badge'

export { Badge, badgeVariants }
export type { BadgeProps }
